import type { AxiosPromise } from 'axios';
import { type ClientContext, ContextClient } from '~/services/contextClient';
import type { ExtendedAxiosRequestConfig } from '~/services/BaseClient';
import FranchiseHubClientFactory from './franchiseHubClient.factory';
import type { FranchiseHubClientInterface, FranchiseHubDashboardResponse } from './franchiseHubClient.types';

class FranchiseHubClient extends ContextClient<FranchiseHubClientInterface> {
    constructor() {
        super(FranchiseHubClientFactory);
    }

    getDashboard(
        context: ClientContext,
        extraConfig?: ExtendedAxiosRequestConfig
    ): AxiosPromise<FranchiseHubDashboardResponse> {
        const client = this.getClient(context);
        return client.getDashboard(extraConfig);
    }
}

export default new FranchiseHubClient();
